import React from 'react';
import { Text } from 'react-native';
import { colors } from '@styleseat/brand';
import type { IRootDispatch } from '../../../store/models';
import { NotificationsAlertTriangleIcon } from '../../../components/ui/Icons';

export function dispatchSuccessSnackbar(dispatch: IRootDispatch, taskLength: number) {
  dispatch.snackbar.open({
    timeOut: 3000,
    sideColor: colors.green,
    header: `Photo${taskLength === 1 ? '' : 's'} successfully uploaded!`,
    dismiss: {
      text: 'Dismiss',
      action: () => {},
    },
    sideContent: (
      <Text style={{ fontSize: 24, lineHeight: 24 }}>
        📸
      </Text>
    ),
  });
}

export function dispatchErrorSnackbar(
  dispatch: IRootDispatch,
  taskLength: number,
  onRetry?: () => void,
) {
  dispatch.snackbar.open({
    sideColor: colors.red,
    header: `We were unable to upload your photo${taskLength === 1 ? '' : 's'}!`,
    subHeader: 'Please try again',
    dismiss: {
      text: 'Dismiss',
      action: () => {},
    },
    confirm: (typeof onRetry === 'function') ? {
      text: 'Retry',
      action: onRetry,
    } : null,
    sideContent: (
      <NotificationsAlertTriangleIcon height={24} width={24} color={colors.red} />
    ),
  });
}

export function dispatchPendingSnackbar(dispatch: IRootDispatch, taskLength: number) {
  dispatch.snackbar.open({
    timeOut: 3000,
    sideColor: colors.green,
    header: `Photo${taskLength === 1 ? '' : 's'} submitted successfully`,
    subHeader: `Your photo${taskLength === 1 ? '' : 's'} may take a few moments to display`,
    dismiss: {
      text: 'Dismiss',
      action: () => {},
    },
    sideContent: (
      <Text style={{ fontSize: 24, lineHeight: 24 }}>
        📸
      </Text>
    ),
  });
}
